import React, { FC } from 'react';
import { Price } from 'components/Common';
import { AppBundle } from 'api/optimalprint-sdk.d';
import styles from './StudioFramePrice.module.scss';

export interface StudioFramePriceProps {
  selectedFrame: AppBundle.Api.Response.ProductUpsell.V1.ProductUpsellScreenV1Response.IUpsellItem | undefined;
  categoryId: number | undefined;
}

const StudioFramePrice: FC<StudioFramePriceProps> = ({ categoryId, selectedFrame }) => {
  return (
    <div className={styles.framePrice}>
      {selectedFrame && selectedFrame.productId > 0 && (
        <Price
          prefix="+"
          categoryId={Number(selectedFrame.categoryId || categoryId)}
          productId={selectedFrame.productId}
        />
      )}
    </div>
  );
};

export default StudioFramePrice;
